<template>
  <div class="context-menu">
    <div class="context-menu-icon"
         @click="isOpen = !isOpen"
    >
      <slot name="icon"></slot>
    </div>
    <div v-if="isOpen"
         class="context-menu-list"
         @mouseleave="mouseLeave()"
    >
      <div v-for="(item, index) in enabledItems"
           :key="`context-menu-item-${index}`"
           class="context-menu-listitem"
           @click="performAction(item.action)"
      >
        <div class="context-menu-listitem-icon">
          <i :class="[`${item.icon}`]"
             class="fas"
          ></i>
        </div>
        <div class="context-menu-listitem-label">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isFunction, filter, get } from 'lodash'

export default {
    name: 'ContextMenu',
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        enabledItems() {
            return filter(this.items, i => get(i, 'if', true))
        },
    },
    methods: {
        async performAction(callable) {
            if (isFunction(callable)) {
                await callable()
            }
            this.isOpen = false
        },
        mouseLeave(e) {
            this.isOpen = false
        },
    },
}
</script>
